module.exports = __webpack_public_path__ + "RMR LSA FAQs.pdf";